import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  total: 0,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case TYPES.GET_CEMEX_TRACKING_ORDERS_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.GET_CEMEX_TRACKING_ORDERS_ERROR:
    case TYPES.CREATE_ERRORS:
      return {
        ...state,
        errorMessages: payload,
        isCreated: false,
        fetching: false,
        list: [],
      };
    case TYPES.GET_CEMEX_TRACKING_ORDERS_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.data],
        fetching: false,
      };
    }

    case TYPES.CLEAR_CEMEX_TRACKING_ORDERS_STATE: {
      return {
        ...state,
        fetching: false,
        errorMessages: null,
        errorMessagesProfile: null,
        isCreated: false,
        createdScannedDocument: {},
      };
    }

    case TYPES.CLEAR_ERRORS: {
      return { ...state, errorMessages: null };
    }

    case TYPES.INIT_REDUCER:
      return {
        ...initialState,
        list: state.list,
        errorMessages: null,
        errorMessagesProfile: null,
      };

    default:
      return { ...state };
  }
}
